import { Obs, useSubtree } from "subtree.js/react";
import { AppActions } from "../app-controller";

/**
 * Shown when Firebase holds a valid session but `GET /user/me` did not return a
 * profile. Treating that as signed-out sends the user to /login, where every
 * sign-in attempt succeeds at Firebase, fails here again and silently returns
 * them to the same page. Signing out is the only real escape, so offer it.
 */
export function ProfileUnavailable() {
  const actions = useSubtree(AppActions);

  return (
    <div className="flex min-h-screen items-center justify-center bg-app p-4">
      <div className="w-full max-w-sm">
        <div className="mb-8 text-center">
          <h1 className="text-3xl font-bold">
            Hobby<span className="text-accent">Scan</span>.Pro
          </h1>
          <p className="mt-1 text-muted">We couldn&apos;t load your account</p>
        </div>

        <Obs>
          {(ref) => {
            const retry = ref.disableUntilCompleted(actions.retryProfile);
            const signOut = ref.disableUntilCompleted(actions.signOut);
            const pending = retry === undefined || signOut === undefined;
            return (
              <div className="panel space-y-5 p-8">
                <p className="text-sm text-muted">
                  You&apos;re signed in, but your profile couldn&apos;t be loaded. This is usually temporary — try again
                  in a moment. If it keeps happening, sign out and back in, or contact support.
                </p>

                <button type="button" onClick={retry} disabled={pending} className="btn-primary w-full">
                  {retry === undefined ? "Retrying…" : "Try again"}
                </button>

                <button type="button" onClick={signOut} disabled={pending} className="btn-secondary w-full">
                  {signOut === undefined ? "Signing out…" : "Sign out"}
                </button>
              </div>
            );
          }}
        </Obs>
      </div>
    </div>
  );
}
